/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Subtitle_Export_Event_Missing_StartInputs */



/**
* | output |
* | --- |
* | "Event {index} is missing a start time. Would you like to ABORT your export?" |
*
* @param {Subtitle_Export_Event_Missing_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_event_missing_start = /** @type {((inputs: Subtitle_Export_Event_Missing_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Event_Missing_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'événement ${i?.index} ne comporte pas d'heure de début.

Souhaitez-vous annuler l'exportation ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Für das Ereignis ${i?.index} fehlt eine Startzeit.
Möchten Sie den Export abbrechen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`All'evento ${i?.index} manca un orario di inizio.
Vuoi ANNULLARE l'esportazione?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index} не имеет времени начала.
Вы хотите прервать экспорт?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Al evento ${i?.index} le falta una hora de inicio.
¿Desea cancelar la exportación?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.index} 缺少开始时间。

是否要中止导出？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index} に開始時刻が指定されていません。
エクスポートを中止しますか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.index} में प्रारंभ समय उपलब्ध नहीं है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O evento ${i?.index} não possui um horário de início.
Deseja CANCELAR a exportação?`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} is missing a start time.
 Would you like to ABORT your export?`)
});